
/* styles */
require("!!../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-5c2fa9ea\",\"scoped\":false,\"hasInlineConfig\":false}!./style/style.css")

var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vux-loader/src/script-loader.js!../../vue-loader/lib/selector?type=script&index=0!./vue-core-image-upload.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5c2fa9ea\"}!../../vux-loader/src/template-loader.js!../../vue-loader/lib/selector?type=template&index=0!./vue-core-image-upload.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-core-image-upload/dist/vue-core-image-upload.vue
// module id = 568
// module chunks = 4